module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/refresh-97760b3d6f447e9d4641c27a7dc1c16e.png";